import React from 'react';
import QlikDropdown from '../Dropdown';
import QlikSearch from '../Search';
import getDoc from "../../qdoc";

export default class QlikFilters extends React.Component {
  constructor(props) {
    super(props);
  }

  clearSelections() {
    getDoc.then(doc => {
      doc.clearAll(false, 'State1');
    });
  }

  render() {
    return (
      <div className="container">
        <div className="filterow mb-5 mt-3">

          <div className="row d-flex justify-content-start">
            {/* <div className="col-auto searchtext">
             SEARCH BY
            </div> */}
            <div className="p-2">
              <QlikSearch qStateName="State1" name="Donor name" field="[Contributor Name]" menuWidth= "320px"/>
            </div>
            <div className="p-2">
              <QlikDropdown qStateName="State1" name="Type" field="[Contributor Type]"/>
            </div>
            <div className="p-2">
              <QlikDropdown qStateName="State1" name="Region" field="[Source]"/>
            </div>
            <div className="p-2 pp">
              <QlikDropdown qStateName="State1" name="Political Party" field="[Political Party Drop Down]" sort="sum([Political Party Group Type])" menuWidth= "300px"/>  
            </div>
            <div className="p-2">
              <QlikDropdown qStateName="State1" name="Year" field="[YearForDropDown]" />  
            </div>
           
            <div className="ml-sm-auto p-2">
              <button className="btn btn-clear" onClick={this.clearSelections}>Clear Selections</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Filters/section3.js